export const REPO_NAME = 'react-pizza-v2';
